export default "__VITE_ASSET__DaWUHhFn__"